const SHOP_DATA = [
  {
    category: "Herico African Jewelry Sets",
    products: [
      {
        id: 1,
        productName: "Adaeze Fashion Set",
        productPrice: 299.99,
        stripePrice: "",
        stripeProduct: "price_1Lq7bfFBFgFoBCrCNYaKlIrL",
        productImage2:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443386/products/adaeze-fashion-set-product-photo-1_cadxoh.jpg",
        productImage1:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443386/products/adaeze-fashion-set-product-photo-2_nptakt.jpg",
        modelImage1:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665030739/products/adaeze-fashion-set-model-photo-1_ignovb.jpg",
        modelImage2:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665031419/products/adaeze-fashion-set-model-photo-2_qnzvpk.jpg",
        category: "Fashion Sets",
        collection: "Herico African Jewelry Sets",
        metals: "Yellow Gold",
        description:
          "A new take on a classic african jewelry set, the Herico African Line Jewelry Set combines our signature Gold Jewelry with the classic feel of a vintage silhouette. Handcrafted in 14-karat gold, the Herico African Line Fashion Set features 3 seperate pieces. The delicate necklace, allows the bracelet and earrings sophisticatedly accompany you on your next event.",
        details: [
          "Metal: 14K Gold Plated",
          "Stones: N/A",
          "Pieces in Set : 3",
          "Ships From : USA",
        ],
      },
      {
        id: 2,
        productName: "Amaka Fashion Set",
        productPrice: 299.99,
        stripePrice: "",
        stripeProduct: "price_1LrV3BFBFgFoBCrCLhP2lAIL",
        productImage1:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443385/products/amaka-fashion-set-product-photo-1_gcjdje.jpg",
        productImage2:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443386/products/amaka-fashion-set-product-photo-2_wyaxnq.jpg",
        modelImage1:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443386/products/amaka-fashion-set-model-photo-1_dfce6n.jpg",
        modelImage2:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443386/products/amaka-fashion-set-model-photo-2_wznn0i.jpg",
        category: "Fashion Sets",
        collection: "Herico African Jewelry Sets",
        metals: "Yellow Gold",
        description:
          "A new take on a classic african jewelry set, the Herico African Line Jewelry Set combines our signature Gold Jewelry with the classic feel of a vintage silhouette. Handcrafted in 18-karat gold, the Herico African Line Fashion Set features 3 seperate pieces. The delicate necklace, allows the bracelet and earrings sophisticatedly accompany you on your next event.",
        details: [
          "Metal: 18K Gold Plated",
          "Stones: N/A",
          "Pieces in Set : 4",
          "Ships From : USA",
        ],
      },
      {
        id: 3,
        productName: "Menala Fashion Set",
        productPrice: 249.99,
        stripePrice: "",
        stripeProduct: "price_1LrV5MFBFgFoBCrCR0rkpHQe",
        productImage2:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443387/products/menala-fashion-set-product-photo-1_xfvzuu.jpg",
        productImage1:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443386/products/menala-fashion-set-product-photo-2_zy3ds1.jpg",
        modelImage1:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443386/products/menala-fashion-set-model-photo-1_l4jegx.jpg",
        modelImage2:
          "https://res.cloudinary.com/doadozwbj/image/upload/v1665443386/products/menala-fashion-set-model-photo-2_ljjbzu.jpg",
        category: "Fashion Sets",
        collection: "Herico African Jewelry Sets",
        metals: "Yellow Gold",
        description:
          "A new take on a classic african jewelry set, the Herico African Line Jewelry Set combines our signature Gold Jewelry with the classic feel of a vintage silhouette. Handcrafted in 14-karat gold, the Herico African Line Fashion Set features 3 seperate pieces. The delicate necklace, allows the bracelet and earrings sophisticatedly accompany you on your next event.",
        details: [
          "Metal: 14K Gold Plated",
          "Stones: N/A",
          "Pieces in Set : 4",
          "Ships From :USA",
        ],
      },
    ],
  },
];

export default SHOP_DATA;
